export { QuizRenderer } from "./QuizRenderer";
